export interface GridDetailsPanelTitle {
    type: 'title';
    text: string;
}

export interface GridDetailsPanelFieldDef<TColumnId> {
    type: 'field';
    field: TColumnId;
    showWhenNil?: boolean;
    hideLabel?: boolean;
}

export type GridDetailsPanelControl<TColumnId> =
    | GridDetailsPanelTitle
    | GridDetailsPanelFieldDef<TColumnId>;

export interface GridDetailsPanelColumnDef<TColumnId> {
    fullWidth?: boolean;
    controls: GridDetailsPanelControl<TColumnId>[];
}

export function getGridPanelRows<TColumnId>(
    columns: GridDetailsPanelColumnDef<TColumnId>[]
): Array<GridDetailsPanelColumnDef<TColumnId>[]> {
    const rows: Array<GridDetailsPanelColumnDef<TColumnId>[]> = [];
    for (const section of columns) {
        const current = rows[rows.length - 1];
        if (!current) {
            rows.push([section]);
        } else {
            if (current[0].fullWidth) {
                rows.push([section]);
            } else {
                if (current.length === 1) {
                    current.push(section);
                } else {
                    rows.push([section]);
                }
            }
        }
    }
    return rows;
}
